import { useState, useEffect } from 'react';

import { useOnUpdateOnly } from 'hooks/UseOnUpdateOnly';

type TProps = {
  onOnline?: () => void;
  onOffline?: () => void;
};

function useNetworkStatusObserver(props?: TProps) {
  // Credit: https://medium.com/the-non-traditional-developer/checking-the-network-connection-with-a-react-hook-ec3d8e4de4ec
  // NB: Will always return true if connected to vpn
  const init =
    typeof window !== 'undefined' && window.navigator.onLine
      ? window.navigator.onLine
      : false;

  const [isOnline, setOnlineStatus] = useState(init);

  const updateNetworkStatus = () => {
    setOnlineStatus(window.navigator.onLine);
  };

  useEffect(() => {
    window.addEventListener('offline', updateNetworkStatus);
    window.addEventListener('online', updateNetworkStatus);

    return () => {
      window.removeEventListener('offline', updateNetworkStatus);
      window.removeEventListener('online', updateNetworkStatus);
    };
  }, []);

  useOnUpdateOnly(() => {
    if (props) {
      isOnline && props.onOnline && props.onOnline();
      !isOnline && props.onOffline && props.onOffline();
    }
  }, [isOnline]);

  return { isOnline };
}

export { useNetworkStatusObserver };
